import React, { useState } from "react";
import { Link } from 'react-router-dom'; // Импортируем Link для переходов
import "../../styles/bedModelPage.css";
import { useLanguage } from "../common/LanguageContext";

function BedModelPage({ title, images, description, variation }) {
  const { translations } = useLanguage();

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const maxVisibleImages = window.innerWidth <= 768 ? 2 : 5; // 2 для мобильной версии, 5 для desktop
  const totalImages = images.length;

  const handlePrev = () => {
    setCurrentImageIndex((prev) => (prev - 1 + totalImages) % totalImages);
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) => (prev + 1) % totalImages);
  };

  // Логика для отображения миниатюр в "карусели"
  const startIndex = Math.max(
    Math.min(currentImageIndex - Math.floor(maxVisibleImages / 2), totalImages - maxVisibleImages),
    0
  );
  const visibleImages = images.slice(startIndex, startIndex + maxVisibleImages);

  return (
    <div className="bed-model-page">
      <h1 className="model-title">{title}</h1>

      {/* Мини-галерея */}
      <div className="mini-gallery">
        <button className="arrow-button left-mini" onClick={handlePrev}>
          <img src="/Slide_Arrow_Left.svg" alt="Previous" />
        </button>
        <div className="mini-gallery-images">
          {visibleImages.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`Thumbnail ${startIndex + idx}`}
              className={`mini-image ${
                startIndex + idx === currentImageIndex ? "active-thumbnail" : ""
              }`}
              onClick={() => setCurrentImageIndex(startIndex + idx)}
            />
          ))}
        </div>
        <button className="arrow-button right-mini" onClick={handleNext}>
          <img src="/Slide_Arrow_Right.svg" alt="Next" />
        </button>
      </div>

      {/* Основное изображение */}
      <div className="main-image-container">
        <h2 className="variation-title">{variation}</h2>
        <div className="main-image-wrapper">
          <button className="arrow-button left" onClick={handlePrev}>
            <img src="/Slide_Arrow_Left.svg" alt="Previous" />
          </button>
          <img src={images[currentImageIndex]} alt="Main Bed Model" className="main-image" />
          <button className="arrow-button right" onClick={handleNext}>
            <img src="/Slide_Arrow_Right.svg" alt="Next" />
          </button>
          <Link
              key={"index"}
              to={"/constructor"} // Путь для перехода
              className="constructor-button"
            >
              {translations.mainPage.buttonsText2} {/* Текст кнопки */}
          </Link>
          {/*<button className="constructor-button">Конструктор</button>*/}
        </div>
        {/* Навигационные кружки */}
        <div className="image-dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentImageIndex ? "active" : ""}`}
              onClick={() => setCurrentImageIndex(index)}
            ></span>
          ))}
        </div>
      </div>

      {/* Описание */}
      <p className="model-description">{description}</p>
    </div>
  );
}

export default BedModelPage;
